import { readItems } from "@directus/sdk";
import { directus } from "../../Api/FetchDirectus";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import minSport from "../../Assets/Images/минспорт_минимал.png";

const Footer = () => {
  const navigate = useNavigate();
  const [menuList, setMenuList] = useState<[]>([]);

  const fetchFooter = async () => {
    try {
      return await directus.request(readItems(`menu_footer`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchMenu = async () => {
    const list: { items: [] } | any = await fetchFooter();
    setMenuList(list.items);
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  return (
    <footer className="footer">
      <div className="footerContent">
        <div className="contactBox">
          <a className="footerPhone" href="tel:84992654432">
            8 (499) 265 44 32
          </a>
          <div className="socialBox">
            <img src={minSport} alt="" />
          </div>
        </div>
        <div className="navigationPanel">
          {menuList.map((item: { link: string; title: string }) => (
            <a href={item.link}>{item.title}</a>
          ))}
        </div>{" "}
        <div className="footerLabelBox">
          <div>Источник изображений freepik.com</div>
          <div>ver0.9566</div>
          <div>© Все права защищены. ЕМИР 2024</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
